import { ChakraProvider } from '@chakra-ui/react';
import chakraTheme from './chakraTheme';
import { ColorModeProvider, type ColorModeProviderProps } from './color-mode';

export function ChakraRootProvider(props: ColorModeProviderProps) {
  return (
    <ChakraProvider value={chakraTheme}>
      <ColorModeProvider {...props} forcedTheme={'light'} />
    </ChakraProvider>
  );
}
